import {Component} from "@angular/core";
import {InventoryEntityModel} from "../../inventory-entity.model";
import {OutletSearchPageComponent} from "../../../../pos/outlet/outlet-search-page/outlet-search-page.component";
import {OutletEditPageComponent} from "../../../../pos/outlet/outlet-edit-page/outlet-edit-page.component";
import {EditService} from "../../../../framework/entity/edit/edit-page/edit.service";
import {EditMode} from "../../../../framework/entity/edit/edit-page/edit-mode";

@Component({
    selector: "wbo-inventory-edit-location",
    templateUrl: "./inventory-edit-location.component.html"
})
export class InventoryEditLocationComponent {
    EditMode = EditMode;
    OutletSearchPageComponent = OutletSearchPageComponent;
    OutletEditPageComponent = OutletEditPageComponent;

    constructor(public model: InventoryEntityModel, public editService: EditService) {
    }
}
